import { isRef } from "vue";
const defined = async (what, signal, bad = [void 0]) => {
  return new Promise(async (resolve) => {
    if (isRef(what)) {
      while (bad.includes(what.value) && (!signal || !signal.aborted)) {
        await new Promise((r) => setTimeout(r, 100));
      }
      resolve(what.value);
    } else {
      while (bad.includes(what) && (!signal || !signal.aborted)) {
        await new Promise((r) => setTimeout(r, 100));
      }
      resolve(what);
    }
  });
};
const arrayOfDefined = async (what, signal, bad = [void 0]) => {
  if (isRef(what) && (!Array.isArray(what.value) || what.value.length === 0) || !isRef(what) && (!Array.isArray(what) || what.length === 0)) {
    return [];
  }
  let ret;
  if (isRef(what)) {
    ret = await Promise.all(
      what.value.map(async (w) => defined(w, signal, bad))
    );
  } else {
    ret = await Promise.all(
      what.map(async (w) => defined(w, signal, bad))
    );
  }
  return ret.filter((r) => !bad.includes(r));
};
const flow = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  arrayOfDefined,
  defined
}, Symbol.toStringTag, { value: "Module" }));
export {
  arrayOfDefined as a,
  defined as d,
  flow as f
};
//# sourceMappingURL=flow-501bd5ba.mjs.map
